import { FieldOption } from '@app/shared/models/field.interface';

export type HierarchySettingsType = 'hierarchies' | 'nodetypes';

export let hierarchySettingsType = {
  HIERARCHIES: 'hierarchies' as HierarchySettingsType,
  NODETYPES: 'nodetypes' as HierarchySettingsType
};

export type NodeTypeTag = 'CONTACT' | 'CUSTOMER' | 'ENSIGN' | 'OTHER' | 'PRODUCT' | 'ROOT' | 'USER';

export let nodeTypeTag = {
  // CONTACT: 'CONTACT' as NodeTypeTag,
  CUSTOMER: 'CUSTOMER' as NodeTypeTag,
  // ENSIGN: 'ENSIGN' as NodeTypeTag,
  OTHER: 'OTHER' as NodeTypeTag,
  PRODUCT: 'PRODUCT' as NodeTypeTag,
  ROOT: 'ROOT' as NodeTypeTag,
  USER: 'USER' as NodeTypeTag
};

export type NodeTypeMode = 'DECODE_TABLE' | 'SERVICE' | 'TABLE' | 'TEXT';

export let nodeTypeMode = {
  DECODED: 'DECODE_TABLE' as NodeTypeMode,
  SERVICE: 'SERVICE' as NodeTypeMode,
  TABLE: 'TABLE' as NodeTypeMode,
  TEXT: 'TEXT' as NodeTypeMode
};

export type NodeAction = 'CUT' | 'COPY' | 'DELETE' | 'EDIT' | 'PASTE';

export let nodeAction = {
  CUT: 'CUT' as NodeAction,
  COPY: 'COPY' as NodeAction,
  DELETE: 'DELETE' as NodeAction,
  EDIT: 'EDIT' as NodeAction,
  PASTE: 'PASTE' as NodeAction
};

export type HierarchyType = 'CUS' | 'PRD' | 'USR';

export let hierarchyTypes = {
  CUS: 'CUS' as HierarchyType,
  PRD: 'PRD' as HierarchyType,
  USR: 'USR' as HierarchyType
};

export type HierarchyFilterType = 'BELOW' | 'ABOVE' | 'CHILDREN' | 'SIBLINGS' | 'BELOW_AND_SIBLING';

export let hierarchyFilterType = {
  BELOW: 'BELOW' as HierarchyFilterType,
  ABOVE: 'ABOVE' as HierarchyFilterType,
  CHILDREN: 'CHILDREN' as HierarchyFilterType,
  SIBLINGS: 'SIBLINGS' as HierarchyFilterType,
  BELOW_AND_SIBLING: 'BELOW_AND_SIBLING' as HierarchyFilterType
};

export type HierarchyFilterEntityType = 'NODE' | 'ELEMENT';

export let hierarchyFilterEntityType = {
  NODE: 'NODE' as HierarchyFilterEntityType,
  ELEMENT: 'ELEMENT' as HierarchyFilterEntityType
};

// TODO: this should be placed in Shared instead
export function getAllYesNoOptions(): FieldOption[] {
  return [
    {
      label: 'core.general.yes',
      value: 'true'
    },
    {
      label: 'core.general.no',
      value: 'false'
    },
    {
      label: 'core.general.all',
      value: ''
    }
  ];
}

// TODO: placed here because of circular dependencies on common-hierarchy-command.service.ts
export function getHierarchyTypesOptions(): FieldOption[] {
  return [
    { label: 'core.general.customers', value: hierarchyTypes.CUS },
    { label: 'core.general.users', value: hierarchyTypes.USR },
    { label: 'core.general.products', value: hierarchyTypes.PRD }
  ];
}

export function getNodeTypesOptions(): FieldOption[] {
  return [
    { label: 'hierarchy.settings.type.freeText', value: nodeTypeMode.TEXT },
    // { label: 'hierarchy.settings.type.existingTable', value: nodeTypeMode.TABLE },
    { label: 'hierarchy.settings.type.decoded', value: nodeTypeMode.DECODED },
    { label: 'hierarchy.settings.type.service', value: nodeTypeMode.SERVICE }
  ];
}

export function getNodeTypeTagsOptions(): FieldOption[] {
  return [
    { label: 'core.general.users', value: nodeTypeTag.USER },
    { label: 'core.general.customers', value: nodeTypeTag.CUSTOMER },
    // { label: 'CONTACT', value: nodeTypeTag.CONTACT },
    // { label: 'ENSIGN', value: nodeTypeTag.ENSIGN }, FIXME: Add tx
    { label: 'core.general.products', value: nodeTypeTag.PRODUCT }
  ];
}
